import { render, staticRenderFns } from "./DeleteEachGroupDialog.vue?vue&type=template&id=3e37c874&scoped=true"
import script from "./DeleteEachGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEachGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteEachGroupDialog.vue?vue&type=style&index=0&id=3e37c874&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e37c874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e37c874')) {
      api.createRecord('3e37c874', component.options)
    } else {
      api.reload('3e37c874', component.options)
    }
    module.hot.accept("./DeleteEachGroupDialog.vue?vue&type=template&id=3e37c874&scoped=true", function () {
      api.rerender('3e37c874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/DeleteEachGroupDialog.vue"
export default component.exports